import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "path": "/contact",
  "pageType": "card",
  "title": "Contact me",
  "backgroundImage": "postbox"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`If you'd like to contact me, please email `}<a parentName="p" {...{
        "href": "mailto:ellis.jp@gmail.com"
      }}>{`ellis.jp@gmail.com`}</a>{`.`}</p>
    <p>{`I can't promise to reply to everything, but anything received will be read.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      